import { Button } from "../ui/button";
import { ComponentProps } from "react";
import { TimeSpanComponentProps } from "./time-span.type";
import { TimeSpanInput } from "types";
import { TimeSpanModal } from "./time-span-modal";
import { callAll } from "helper/utils";
import clsx from "clsx";
import { formatDate } from "helper/date-time";
import useToggle from "hooks/use-toggle";

export interface TimeSpanProps extends ComponentProps<"button">, Pick<TimeSpanComponentProps, "options" | "label"> {
  timeSpan: TimeSpanInput;
  onChangeValue?: (timeSpan: TimeSpanInput) => void;
  className?: string;
  name?: string;
  readonly?: boolean;
}

export const TimeSpanItem = ({
  onChangeValue,
  timeSpan,
  className,
  label,
  options,
  readonly = false,
  onClick,
  ...buttonProps
}: TimeSpanProps) => {
  const [showPopup, setShowPopup] = useToggle();

  const onApply = (input: TimeSpanInput) => {
    if (onChangeValue) {
      onChangeValue(input);
    }
    setShowPopup();
  };

  return (
    <>
      <div className="flex flex-col w-full">
        <Button
          className={clsx("flex w-full h-full", className)}
          {...buttonProps}
          onClick={callAll(onClick, setShowPopup)}
          disabled={readonly}
          variant="ghost"
          type="button"
        >
          <TimeSpanContent timeSpan={timeSpan} options={options} />
        </Button>
      </div>

      {showPopup && (
        <TimeSpanModal
          label={label}
          timeSpanData={timeSpan}
          onApply={onApply}
          onDismiss={setShowPopup}
          options={options}
        />
      )}
    </>
  );
};

export const TimeSpanContent = ({ options, timeSpan }: TimeSpanProps) => {
  return (
    <div className="flex flex-col text-xs text-left w-full">
      {options?.showSelectDate && (
        <>
          <span>
            Start date: {timeSpan?.startDate && formatDate(timeSpan.startDate, { format: "d MMM yyyy" })}{" "}
            {timeSpan?.timeOfDayStart && timeSpan.timeOfDayStart}
          </span>
          <span>
            End date: {timeSpan?.endDate && formatDate(timeSpan.endDate, { format: "d MMM yyyy" })}{" "}
            {timeSpan?.timeOfDayEnd && timeSpan.timeOfDayEnd}
          </span>
        </>
      )}
      {options?.showDesignatedPeriod && <span>Designated Period: {timeSpan?.designatedPeriod}</span>}
      {options?.showDesignatedPeriodExcept && (
        <span>
          Designated Period Except:{" "}
          {typeof timeSpan?.designatedPeriodExcept === "boolean" && String(timeSpan.designatedPeriodExcept)}
        </span>
      )}
      <span>Days of week: {timeSpan.daysOfWeek?.join(", ")}</span>
      <span>Days of month: {timeSpan.daysOfMonth?.join(", ")}</span>
      <span>Month: {timeSpan.months?.join(", ")}</span>
    </div>
  );
};
